import { type ReactNode, type FC } from 'react';
import { Space } from '@g2u/ui-kit';

import { type WithOptionalDataTest } from 'types';

type Props = {
  hasSlot?: boolean;
  children?: ReactNode;
} & WithOptionalDataTest;

export const PopconfirmDescription: FC<Props> = (props) => {
  const { hasSlot, children } = props;

  return (
    <Space.$ direction={Space.Direction.Vertical} size={Space.Size.ExtraSmall}>
      {children ?? (
        <>
          {hasSlot ? (
            <>The information you have entered and the selected time slot will be lost.</>
          ) : (
            <>The information you have entered will be lost.</>
          )}
          <>Do you want to continue?</>
        </>
      )}
    </Space.$>
  );
};
